<script lang="ts" setup>
import { formatNumber } from '@/home/utils/format';
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';
import Box from './Box.vue';
import Loading from '@/home/components/Loading.vue';
import LoadingBox from '@/home/components/LoadingBox.vue';

const { $fetch } = useFetch();

const { data: listing, pending } = useAsyncData(
  'home:column',
  () => $fetch('/popSpecialColumn/getColumnPage',
    {
      method: 'post',
      data: { pageNum: 1, pageSize: 8 },
    }),
  {
    transform: (data) => data.records ?? [],
  },
);
</script>

<template>
  <section class="page-home-repository mt-20">
    <Box :title="$t('home.home.column.title')">
      <ul>
        <LoadingBox :loading="pending">
          <template v-if="listing?.length > 0">
            <li v-for="item in listing" :key="item.url" class="group mt-20 cursor-pointer border-b-1 border-hex-f7f7f7 pb-20 last:border-b-0 last:pb-0">
              <RouterLink :to="`/column/detail/${item.columnId}`" target="_blank">
                <div class="flex justify-between gap-x-12">
                  <div class="line-clamp-1 break-anywhere text-16 color-hex-292929 font-500 leading-22 group-hover:color-hex-345de2">
                    {{ item.columnName }}
                  </div>
                  <div class="flex-y-center gap-4 text-12px color-hex-575757 font-400">
                    <div class="i-icons:fire size-16 text-#E24E40"></div>
                    <div>{{ formatNumber(item.totalScore) }}</div>
                  </div>
                </div>
                <p class="line-clamp-2 mt-6 h-44 max-h-0 overflow-hidden text-14 color-hex-575757 font-400 leading-22 transition-all duration-300 ease-in-out group-hover:max-h-44" :title="item.description">
                  {{ item.columnDesc }}
                </p>
              </RouterLink>
            </li>
          </template>
          <template v-else>
            <li class="mt-20 text-center color-hex-8b8b8b">{{ $t('home.common.emptyContent') }}</li>
          </template>

          <template #loading>
            <li class="mt-20 flex-x-center">
              <Loading class="size-16 color-hex-8b8b8b" />
            </li>
          </template>
        </LoadingBox>
      </ul>
    </Box>
  </section>
</template>

<style lang="scss" scoped>
</style>
